import { render } from "./CategoryRow.vue?vue&type=template&id=760afbb1&scoped=true"
import script from "./CategoryRow.vue?vue&type=script&lang=js"
export * from "./CategoryRow.vue?vue&type=script&lang=js"

import "./CategoryRow.vue?vue&type=style&index=0&id=760afbb1&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760afbb1"]])

export default __exports__